import { MapUiTheme } from '../../common';

export const radioTheme = {
  defaultStyles: {
    padding: (theme: MapUiTheme) => theme.spacing[4],
    display: 'block',
    position: 'relative',
    paddingLeft: (theme: MapUiTheme) => theme.spacing[11],
    marginBottom: '0px',
    cursor: 'pointer',
    fontSize: (theme: MapUiTheme) => theme.fontSize.base,
    marginRight: (theme: MapUiTheme) => theme.spacing[4],
    backgroundColor: (theme: MapUiTheme) => theme.colors.white,

    '& .__mapui_radioInput': {
      position: 'absolute',
      zIndex: (theme: MapUiTheme) => theme.zIndices.hide,
      opacity: '0',

      '&:not(:checked) ~ .__mapui_radioControl': {
        border: (theme: MapUiTheme) => '1px solid ' + theme.colors.neutral500,
      },

      '&:checked ~ .__mapui_radioControl': {
        background: (theme: MapUiTheme) => theme.colors.white,
        border: (theme: MapUiTheme) =>
          '2px solid ' + theme.colors.interaction200,
      },

      '&:disabled ~ .__mapui_radioControl': {
        background: (theme: MapUiTheme) => theme.colors.neutral100,
        opacity: '1',
        border: (theme: MapUiTheme) => '1px solid ' + theme.colors.neutral500,
      },

      '&:disabled ~ .__mapui_radioControl:after': {
        background: (theme: MapUiTheme) => theme.colors.neutral300,
        left: '4px',
        top: '4px',
      },

      '&:checked ~ .__mapui_radioControl:after': {
        display: 'block',
      },
    },

    '& .__mapui_radioControl': {
      borderRadius: '50%',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      left: '22px',
      height: '24px',
      width: '24px',
      border: (theme: MapUiTheme) => `2px solid ${theme.colors.neutral500}`,

      '&:after': {
        boxSizing: 'unset',
        content: "''",
        position: 'absolute',
        display: 'none',
        left: '3px',
        top: '3px',
        height: '14px',
        width: '14px',
        borderRadius: '50%',
        background: (theme: MapUiTheme) => theme.colors.interaction200,
      },

      '&::before': {
        content: "''",
        display: 'block',
        position: 'absolute',
        left: '0',
        top: '0',
        width: '4.5rem',
        height: '4.5rem',
        marginLeft: '-1.3rem',
        marginTop: '-1.3rem',
        background: (theme: MapUiTheme) => theme.colors.interaction200,
        borderRadius: '3rem',
        opacity: '0.6',
        transform: 'scale(0)',
      },
    },
  },

  hasBorder: {
    border: (theme: MapUiTheme) => `solid 1px ${theme.colors.neutral500}`,
    borderRadius: '8px',
  },
};
